export const QUERY_MASTER_COLUMN_CONFIG = `
  MasterColumnConfig($where: master_column_config_bool_exp!) {
    master_column_config(where: $where) {
      id
      project_id
      subscription_id
      feature_type_id
      column_config
    }
  }
`;
